import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import { IQuestionBankQuestion } from 'interfaces/questionBank'
import { Wrapper } from './styled'

interface IProps {
  question: IQuestionBankQuestion
  setQuestion: (value: IQuestionBankQuestion) => void
}

const Inputs = ({ question, setQuestion }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix =
    'administration.blocks.type.questionBankV2.sections.manageQuestion'

  return (
    <Wrapper>
      <div>{t(`${translationPrefix}.name.title`)}</div>
      <Input
        value={question.name}
        onChange={(e) => setQuestion({ ...question, name: e.target.value })}
        placeholder={t(`${translationPrefix}.name.placeholder`)}
        autoFocus
      />
    </Wrapper>
  )
}

export default Inputs
